/**
 * Dialog for displaying a confirmation message and two options: no or yes.
 * No indicates the user did not accept the terms of the message, while
 * yes indicates the user accepts the terms of the message.
 */

import { Component, input, OnInit, output } from '@angular/core';
import { EmrDialogComponent } from '../emr-dialog/emr-dialog.component';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'emr-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  standalone: true,
  imports: [
    DialogModule,
    ButtonModule,
  ],
})
export class ConfirmationDialogComponent extends EmrDialogComponent implements OnInit {
  /**
   * Flag indicating whether the button that tells if the user has confirmed
   * or not should be disabled. This is used to dynamically enable/disable
   * the confirm button.
   */
  confirmDisabled = input(false);

  /**
   * For emitting whether the user confirmed or not back to the parent component.
   */
  dialogClose = output<boolean>();

  ngOnInit(): void { }

  /**
   *
   * @param didConfirm Whether the user clicked the confirm button or not.
   */
  closeDialog(didConfirm: boolean) {
    this.dialogClose.emit(didConfirm);
    super.closeDialog();
  }
}
